module.exports = __webpack_public_path__ + "static/media/brewfest-flyer-2019.45d8b17b.pdf";